class ContentFilter {
    constructor(el) {
        this.el = el;

        this.nav = this.el.querySelector('.content-filter-nav');

        if(this.nav) {
            this.navItems = this.nav.querySelectorAll('.content-filter-nav--item');
        }

        if(!this.navItems) return;

        this.activeItem = this.nav.querySelector('.active');
        this.activeFilter = this.activeItem.dataset.filter;

        this.init();
    }

    init() {
        console.log('ContentFilter');
        console.log(this.el);
        // this.filter = this.el.querySelector('.content-filter--filter');
        // this.items = this.el.querySelectorAll('.content-filter--item');
        this.initItems();
        this.filterItems();
        this.initEvents();
    }

    initItems() {
        this.items = this.el.querySelectorAll('.content-filter--item');
    }

    filterItems() {
        this.items.forEach((el) => {
            if(this.activeFilter == 'all' || el.dataset.filter == this.activeFilter) {
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });
    }

    initEvents() {
        this.navItems.forEach((el) => {
            el.addEventListener('click', this.onNavClick.bind(this));
        });
    }

    onNavClick(e) {
        e.preventDefault();
        const item = e.currentTarget;
        if(item == this.activeItem) return;

        this.activeItem.classList.remove('active');
        this.activeItem = item;
        this.activeItem.classList.add('active');
        this.activeFilter = this.activeItem.dataset.filter;
        console.log(this.activeFilter);

        this.filterItems();
    }
}

export default ContentFilter;
